document.addEventListener("DOMContentLoaded", function() {
    // Array mit rotierenden Nachrichten
    let messages = [
        "KOSTENLOSER VERSAND AB 100€",
        "MIT 💚 GEFERTIGT IN DEUTSCHLAND",
        "PERSONALISIERBARE PRODUKTE",
        "🌱 KLIMAFREUNDLICHER VERSAND",
        "🌳 WIR PFLANZEN BÄUME",
        "⭐⭐⭐⭐⭐ BEWERTUNGEN",
    ];
    
    let announcementText = document.querySelector(".announcement__text");
    
    if (announcementText) {
        let index = 0;
        
        function updateText() {
            announcementText.textContent = messages[index];
            index = (index + 1) % messages.length;
        }

        updateText(); // Zeigt die erste Nachricht an
        setInterval(updateText, 5000); // Alle 5 Sekunden wechseln
    }
});
